import { ReactElement } from "react";
import { AdvertisementTypeEnum } from "@app/types/enums";
import Advertisement from "@components/Advertisement/Advertisement";
import FooterSubscribeRow from "@components/Footer/FooterSubscribeRow/FooterSubscribeRow";
import Header from "@components/Header/Header";
import { getStatusCodeErrorMessage, GoogleAdsSlotFactory } from "@util/helpers";

type CustomErrorProps = {
  statusCode?: number;
};

export default function CustomError({
  statusCode = 404,
}: CustomErrorProps): ReactElement {
  const errorMessage = getStatusCodeErrorMessage(statusCode);

  return (
    <>
      <Advertisement
        adUnitProps={{
          type: AdvertisementTypeEnum.LB1,
          slot: GoogleAdsSlotFactory.lb1("homepage"),
        }}
      />

      <Header />

      <div className="container px-3 py-3">
        <p className="mb-0 mt-3">{errorMessage}</p>
      </div>

      <FooterSubscribeRow />
    </>
  );
}
